import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
interface NavbarProps {
  onSupportClick?: () => void;
}
export function Navbar({
  onSupportClick
}: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Philosophy',
    href: '#philosophy'
  }, {
    name: 'Legacy',
    href: '#legacy'
  }, {
    name: 'The Fund',
    href: '#fund'
  }];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.8,
    ease: [0.16, 1, 0.3, 1]
  }} className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${isScrolled ? 'bg-[#F5F0E8]/95 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-146">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-center items-center" data-id="element-147">
        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-10" data-id="element-148">
          {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium tracking-wider uppercase transition-colors duration-300 hover:text-[#B8860B] ${isScrolled ? 'text-[#1A1A1A]/70' : 'text-[#F5F0E8]/80'}`} data-id="element-149">
              {link.name}
            </a>)}
          <button onClick={onSupportClick} className={`text-sm font-medium tracking-wider uppercase px-5 py-2 transition-all duration-300 ${isScrolled ? 'bg-[#1B2A4A] text-[#F5F0E8] hover:bg-[#1B2A4A]/90' : 'bg-[#B8860B] text-[#F5F0E8] hover:bg-[#B8860B]/90'}`} data-id="element-150">
            Support
          </button>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-151">
          {mobileMenuOpen ? <X className={isScrolled ? 'text-[#1A1A1A]' : 'text-[#F5F0E8]'} data-id="element-152" /> : <Menu className={isScrolled ? 'text-[#1A1A1A]' : 'text-[#F5F0E8]'} data-id="element-153" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-154">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-[#F5F0E8] border-t border-[#1A1A1A]/10 overflow-hidden" data-id="element-155">
            <div className="px-6 py-4 flex flex-col space-y-4" data-id="element-156">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-[#1A1A1A] font-serif text-lg py-2 border-b border-[#1A1A1A]/5" data-id="element-157">
                  {link.name}
                </a>)}
              <button onClick={() => {
            setMobileMenuOpen(false);
            onSupportClick?.();
          }} className="text-left text-[#B8860B] font-serif text-lg py-2 font-medium" data-id="element-158">
                Support the Legacy
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.nav>;
}